import { render, staticRenderFns } from "./Single-Visit-Detail.vue?vue&type=template&id=4c669e9c&scoped=true"
import script from "./Single-Visit-Detail.vue?vue&type=script&lang=js"
export * from "./Single-Visit-Detail.vue?vue&type=script&lang=js"
import style0 from "./Single-Visit-Detail.vue?vue&type=style&index=0&id=4c669e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c669e9c",
  null
  
)

export default component.exports